import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { InvoiceEditDueFormViewProps } from "models/propTypes/invoicePropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { DateInputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { DateInput, useWintForm, VerticalFormField, WintForm } from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const InvoiceEditDueForm: ForwardRefRenderFunction<FormHandles, InvoiceEditDueFormViewProps> = (props, ref) => {
  const { wintFormProps, connect } = useWintForm<InvoiceFormTypes.EditDueDate>({
    formRef: ref,
    ...props,
    validateOnBlur: true,
  });

  return (
    <WintForm {...wintFormProps}>
      <Grid xs={6}>
        <VerticalFormField<DateInputProps>
          Component={DateInput}
          {...connect("dueDate")}
          controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ChangeDueDate)}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DueDate)}
          minDate={DateHelper.addDays(props.invoiceDate, 1)}
          showMainLabel
        />
      </Grid>
    </WintForm>
  );
};

export default forwardRef(InvoiceEditDueForm);
